export default __webpack_public_path__ + "static/stbill-67fee2b60dfa1168e2e8105ae54ca384.png";